import { getIdTokenHttp } from '~/src/repositories/id-token/id-token.repository';

export const IdTokenService = {
    getIdTokenHttp,
};
